import { PageContextUtils, LazyLoadUtils } from "../../utils/index.js";

export const CrossActivity = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "crossactivity/pc/crossActivity" */ "./CrossActivity.pc.js"
    ),
  { componentName: "CrossActivity" }
);

export const MobileCrossActivity = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "crossactivity/mobile/crossActivity" */ "./CrossActivity.mobile.js"
    ),
  { componentName: "MobileCrossActivity" }
);

export const getCrossSellPC = async (brandId, clientProvider) => {
  try {
    const { getCrossSell } = await import(
      /* webpackChunkName: "[request]" */
      `../Brands/${brandId}/${clientProvider}/CrossActivity.resource.js`
    );

    return getCrossSell;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const getCrossSellMobile = async (brandId, clientProvider) => {
  try {
    const { getCrossSell } = await import(
      /* webpackChunkName: "[request]" */
      `../Brands/${brandId}/${clientProvider}/MobileCrossActivity.resource.js`
    );

    return getCrossSell;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const preloadResources = async isPC => {
  const brandId = window.__UAA_STATE__?.userContext.brandId;
  const { name } = PageContextUtils.getClientProviderData();

  if (isPC) {
    getCrossSellPC(brandId, name);
  } else {
    getCrossSellMobile(brandId, name);
  }
};
